import Vue from 'vue'
import Vuex from 'vuex'
import theme from './modules/theme'
import company from './modules/company'
import createLogger from '../plugins/logger'

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
  modules: {
    theme,
    company
  },
  strict: debug,
  plugins: debug ? [createLogger()] : []
})



// WEBPACK FOOTER //
// ./src/store/index.js